/// SHARED VARIABLES
/// (Ideally wrap these in an interface)
const { client } = require('./client');
const { reactRender } = require('./reactRender');
const { fetchReplay } = require('./replayFetcher');
const seedRandom = require('seed-random');


var replay = { };

var GAME_CONST = {
    MAX_BULLETS: 10,
    SHOOT_ROF: 500,
    BULLET_REGEN: 10 * 1000,
    BASE_BULLET_LIFETIME: 600,
    PLAYER_SPEED: 13.0,
    BULLET_SPEED: 5.0,
    INVIS_TIME: 7.5 * 1000,
    REVEAL_TIMER: 35 * 1000,
};


/*
todo:


*/

// data.events = list of events
/*
	kinds of objects:
	players
		-moves // a list of movements taken  toX, toY, fromX, fromY, start, end

	bullets
	powerups
	bodies - which are just players with different draw code
	all players stick around until the end.  They just draw differently past their death time.
*/

// top level - clusters of objects
// clusters of objects have a start time and lifetime and then a list of objects
// all objects are a draw function of time

const PlayerSpawn = 0;
const PlayerMove = 1;
const PlayerInvis = 2;
const BulletSpawn = 3;
const PowerupSpawn = 4;

var returnToMainMenuFunction;
var gameObjects = [];
var backButtonText = "";

replay.entry = function(id, returnToMainMenu, playerId, inBackButtonText) {

	backButtonText = "< " + (inBackButtonText ? inBackButtonText : "Main Menu");

	this.replayId = id;
	this.playerId = playerId;
	// console.log("replay.entry = function(id, returnToMainMenu) {", returnToMainMenu);
	returnToMainMenuFunction = returnToMainMenu;

	console.log("replay.entry: " + id);

	this.isPaused = false;
	this.timeline = null;
	this.time = 0;
	this.endTime = 1000 * 10;
	this.renderReplayUI();

	fetchReplay(id).then(replay => {

		console.log(replay);
		this.startReplay(replay);

	}).catch(err => {

		console.log("hi");
		reactRender.showAlert("Cannot get replay.  Try refreshing the page", true);
	});

	constructGameHTML();

	var s = 64;
	var alpha = 1.5;
	for (var x = 0; x < w; x += s)
	{
		for (var y = 0; y < w; y += s)
		{
			addGameObj(new Box(x, y, s * 0.9, s * 0.9, alpha));
			alpha += 0.05;
		}
	}
}

function addGameObj(newObj) {
  newObj.kill = function() {this.toKill = true;};
  gameObjects.unshift(newObj);
}

replay.renderReplayUI = function() {
	var replayUrl = "/replay/" + this.replayId;
	if (this.playerId)
		replayUrl += "?p=" + this.playerId;

	reactRender.replay(this.time / this.endTime, this.isPaused, this.clickPlay.bind(this), this.clickScrubber.bind(this), 
		() => { 

			if (window.location.pathname.startsWith("/replay/"))
			{
				window.location.href="../"
			}
			else
			{
				endGame(); 
				returnToMainMenuFunction(); 
			}
		},
		replayUrl,
		backButtonText
	);
}

replay.clickPlay = function() {

	if (this.time >= this.endTime)
	{
		this.time = 0;
		this.isPaused = false;
	}
	else
		this.isPaused = !this.isPaused;	

	this.renderReplayUI();
}

replay.clickScrubber = function(event) {
	this.time = ((event.clientX - canvas.width * 0.1 - elemLeft) / (canvas.width * 0.8)) * this.endTime;

	if (this.time < 0)
		this.time = 0;
	if (this.time > this.endTime)
		this.time = this.endTime;

	this.renderReplayUI();
}

replay.startReplay = function(replay) {

	if (this.timeline)
		return; 

	this.timeline = [ ];
	this.players = { };
	this.ais = [ ];

	replay.events.forEach((event) => {
		switch (event.type) {
			case PlayerSpawn:
			{
				let player = new Player(event.id, event.startTime, event.endTime, event.real);
				this.players[event.id] = player;
				this.timeline.push(player);
				if (!event.real)
					this.ais.push(player);
			}
			break;

			case PlayerMove:
			{
				let player = this.players[event.id];
				if (player)
					player.move(event.toX, event.toY, event.startTime);
			}
			break;

			case PlayerInvis:
			{
				let player = this.players[event.id];
				if (player)
					player.doInvis(event.startTime);
			}
			break;


			case BulletSpawn:
			{
				let bullet = new Bullet(event.x, event.y, event.toX, event.toY, event.startTime);
				this.timeline.push(bullet);
			}
			break;


			case PowerupSpawn:
			{
				let power = new Powerup(event.x, event.y, event.startTime, event.endTime);
				this.timeline.push(power);
			}
			break;

		};
	});

	if (replay.header.endTime)
		this.endTime = replay.header.endTime;

	this.moveRandom = seedRandom(replay.header.moveSeed);

	for (var time = replay.header.firstStep + 20; time < this.endTime; time += 42)
	{
		for (var i = 0; i < this.ais.length; i++) {

			var ai = this.ais[i];
			if (time >= ai.start && time < ai.end && ai.rand() > 0.995)
				ai.aiMove(time);
		}
	}

	this.draw();
}

function Bullet(x, y, toX, toY, start) {

	this.x = x;
	this.y = y;
	this.start = start;

	var dist = Math.sqrt((toX - x) * (toX - x) + (toY - y) * (toY - y));
	console.log(x + ", " + y + " : " + toX + ", " + toY + " = " + dist);
	var timeAlive =  dist * GAME_CONST.BULLET_SPEED;
	console.log("timeAlive: " + timeAlive);
	this.end = start + timeAlive;

	this.dx = (toX - x) / timeAlive;
	this.dy = (toY - y) / timeAlive;
}

Bullet.prototype.draw = function(time) {

	if (time >= this.start && time < this.end)
	{
		var dt = time - this.start;
		var x = this.x + this.dx * dt;
		var y = this.y + this.dy * dt;

		ctx.globalAlpha = 1.0;
		ctx.fillStyle = "#FF0000";
		ctx.fillRect(x - 4, y - 4, 8, 8);
	}
}

function Powerup(x, y, start, end) {

	this.x = x;
	this.y = y;
	this.start = start;
	this.end = end;
}

Powerup.prototype.draw = function(time) {

	if (time >= this.start && time < this.end)
	{
		ctx.globalAlpha = 1.0;
		ctx.lineWidth = 1;
		ctx.fillStyle = "#00FF00";
		ctx.fillRect(this.x - 4, this.y - 4, 8, 8);

		ctx.globalAlpha = 0.2;
		ctx.beginPath();
		ctx.arc(this.x, this.y, 30, 0, 2 * Math.PI);
		ctx.fill();

		ctx.globalAlpha = 0.05;
		ctx.beginPath();
		ctx.arc(this.x, this.y, 120, 0, 2 * Math.PI);
		ctx.fill();

		ctx.globalAlpha = 1.0;
		var size2 = 10;
		ctx.beginPath();
		ctx.strokeStyle = "#000000";
		ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
		ctx.stroke();
	}
}

function Player(id, start, end, isReal) {

	this.rand = seedRandom(id);
	var x = this.rand() * w;
	var y = this.rand() * h;

	this.startX = x;
	this.startY = y;

	this.start = start;
	this.end = end;

	this.id = id;

	this.moves = [];

	var newMove = { };

	newMove.fromX = x;
	newMove.fromY = y;

	newMove.toX = x;
	newMove.toY = y;

	newMove.start = start;
	newMove.end = start;

	this.moves.push(newMove);
	this.isReal = isReal;
}

Player.prototype.doInvis = function(time) {

	if (!this.invis)
		this.invis = [];

	var newInvis = { };
	newInvis.start = time;
	newInvis.end = time + GAME_CONST.INVIS_TIME;

	this.invis.push(newInvis);
}

Player.prototype.aiMove = function(time) {

	var xy = this.getPos(time);

	var size = 550;
	var x = xy.x + size / 2 - size * this.rand();
	if (x < 0)
	  x += size;
	if (x > w)
	  x -= size;

	var y = xy.y + size / 2 - size * this.rand();
	if (y < 0)
	  y += size;
	if (y > h)
	  y -= size;

	if (this.rand() > 0.5) {
	  var mini = 20;
	  if (this.rand() > 0.5)
	    x = xy.x + mini / 2 - mini * this.rand();
	  else
	    y = xy.y + mini / 2 - mini * this.rand();
	}

	this.move(x, y, time);
}

Player.prototype.move = function(x, y, time) {

	var move = this.moves[this.moves.length - 1];

	var dist = (time - move.start) / (move.end - move.start);
	if (dist > 1)
		dist = 1;

	var oldX = move.fromX + (move.toX - move.fromX) * dist;
	var oldY = move.fromY + (move.toY - move.fromY) * dist;

	var newMove = { };

	newMove.fromX = oldX;
	newMove.fromY = oldY;

	newMove.toX = x;
	newMove.toY = y;

	newMove.start = time;
	newMove.end = time + Math.sqrt((oldX - x) * (oldX - x) + (oldY - y) * (oldY - y)) * GAME_CONST.PLAYER_SPEED;

	this.moves.push(newMove);
}

Player.prototype.getPos = function(time) {

	if (time > this.end)
		time = this.end;

	var pos = { };
	var x = this.startX;
	var y = this.startY;

	if (this.moves.length > 0)
	{
		x = this.moves[0].fromX;
		y = this.moves[0].fromY;
	}

	for (var i = this.moves.length - 1; i >= 0; i--) {

		var move = this.moves[i];
		var prevMove = this.moves[i - 1];

		if (move.start <= time) {

			var dist = (time - move.start) / (move.end - move.start);
			if (dist > 1)
				dist = 1;

			x = move.fromX + (move.toX - move.fromX) * dist;
			y = move.fromY + (move.toY - move.fromY) * dist;
			break;
		}
	}

	pos.x = x;
	pos.y = y;
	return pos;
}


Player.prototype.draw = function(time) {

	//temp
	//if (!this.isReal)
	//	return;

	// console.log(time + ">=" + this.start);
	if (time >= this.start) {

		var xy = this.getPos(time);
		var x = xy.x;
		var y = xy.y;

		if (time > this.end)
		{
			ctx.globalAlpha = 1.0;
			ctx.strokeStyle = "#000000";

			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.rect(x - 4, y - 4, 7, 7);
			ctx.stroke();

			if (this.isReal) {
			  ctx.strokeStyle = "#FF0000";
			  ctx.beginPath();

			  ctx.moveTo(x - 20, y - 20);
			  ctx.lineTo(x + 20, y + 20);

			  ctx.moveTo(x + 20, y - 20);
			  ctx.lineTo(x - 20, y + 20);
			  ctx.stroke();
			}
		}
		else
		{
		    ctx.fillStyle = "#000000";
		    ctx.strokeStyle = "#000000";
			var size = 12;
			var size2 = 16;
			var size3 = 24;

			if (this.isReal)
			{
				size += 2;
				size2 += 2;

				ctx.globalAlpha = 1.0;
				var isInvis = false;
				if (this.invis)
				{
					for (var i = this.invis.length - 1; i >= 0; i--) {
						var invis = this.invis[i];
						if (time >= invis.start)
						{
							if (time < invis.end)
							{
								ctx.fillStyle = "#0000FF";		
								ctx.strokeStyle = "#0000FF";		

								ctx.beginPath();
								ctx.lineWidth = 2.5;
								ctx.strokeStyle = "#0000FF";
								ctx.arc(x, y, 24, 0, 2 * Math.PI * (time - invis.start) / (GAME_CONST.INVIS_TIME));

								ctx.stroke();
								ctx.lineWidth = 1;
								isInvis = true;
							}
							break;
						}
					}
				}

				if (this.id == replay.playerId)
				{
				    ctx.fillStyle = "#FF0000";
				    ctx.strokeStyle = "#FF0000";

					ctx.textAlign = "center";
					ctx.font = "12px Arial";
				  	ctx.fillText("You", x, y - 22);
				}

				if (isInvis)
				{
					ctx.fillStyle = "#0000FF";		
					ctx.strokeStyle = "#0000FF";	
				}

				ctx.beginPath();
				ctx.rect(x - size2 / 2, y - size2 / 2, size2, size2);
				ctx.stroke();
			}
			else
				ctx.globalAlpha = 0.5;

			// console.log(x, y);
			ctx.fillRect(x - size / 2, y - size / 2, size, size);

			var glowEndTime = 1000 * 10;
			if (this.id == replay.playerId && replay.time < glowEndTime)
			{
				ctx.globalAlpha = (1.0 - replay.time / glowEndTime) * 0.2;

				ctx.fillRect(0, y - size / 2, 1000, size);
				ctx.fillRect(x - size / 2, 0, size, 1000);
			}
		}
	}
}

var canvas;
var gameDiv;
var ctx;
var upperPadding = 0;
var lowerPadding = 0;
var gameScale = 1;
var w = 640;
var h = 480;

function endGame() {

  if (gameDiv)
  {
    document.body.removeChild(gameDiv);
    gameDiv = null;
  }
}
function constructGameHTML() {

  gameDiv = document.createElement("div");
  gameDiv.className = 'container';

  var image = document.createElement('div');
  image.className = "background";

  canvas = document.createElement('canvas');
  canvas.className = "gameCanvas";

  canvas.width = Math.min(reactRender.MAX_WIDTH, window.innerWidth) - 2;
  canvas.height = Math.min(reactRender.MAX_HEIGHT, window.innerHeight) - 2;

  var scaledGameH = canvas.width * (h / w);
  if (canvas.height > scaledGameH)
  {
    upperPadding = lowerPadding = (canvas.height - scaledGameH) / 2;
  }

  var gameCanvasHeight = canvas.height - upperPadding - lowerPadding;
  gameScale = Math.min(gameCanvasHeight / h, canvas.width / w);

  ctx = canvas.getContext("2d");

  gameDiv.append(image);
  gameDiv.append(canvas);

  document.body.append(gameDiv);

  elemLeft = canvas.parentElement.offsetLeft;
  elemTop = canvas.parentElement.offsetTop;
}

var timeNow, lastTime;
replay.draw = function() {

	if (!gameDiv)
		return;

	timeNow = new Date().getTime();
	if (!lastTime)
		lastTime = timeNow;

	var dTime = timeNow - lastTime;
	if (dTime > 60)
		dTime = 60;

	if (!this.isPaused)
	{
		this.time += dTime;
		if (this.time > this.endTime)
		{
			this.time = this.endTime;
			this.isPaused = true;
		}
	}

	ctx.save();
	ctx.setTransform(1, 0, 0, 1, 0, 0);
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	ctx.scale(gameScale, gameScale);

	ctx.font = "16px Arial";
	ctx.textAlign = "left";
	ctx.fillStyle = "#999999";
	ctx.globalAlpha = 1.0;

	ctx.lineWidth = 1;
	ctx.translate(0, upperPadding);

	for (var i = 0; i < this.timeline.length; i++) {
		var obj = this.timeline[i];
		obj.draw(this.time, ctx);
	}

	for (var i = 0; i < gameObjects.length; i++) {
	  var obj = gameObjects[i];
	  if (!obj.toKill)
	    obj.update(dTime, ctx);
	}

	lastTime = timeNow;

	// upper UI
	ctx.setTransform(1, 0, 0, 1, 0, 0);

	ctx.fillStyle = "rgb(255, 254, 254)";
	ctx.globalAlpha = 1;

	if (upperPadding > 0)
		ctx.fillRect(0, 0, canvas.width, upperPadding);
	if (lowerPadding > 0)
		ctx.fillRect(0, canvas.height - lowerPadding, canvas.width, lowerPadding);

	ctx.fillStyle = "rgb(200, 200, 200)";
	if (upperPadding > 0)
		ctx.fillRect(0, upperPadding, canvas.width, 1);
	if (lowerPadding > 0)
		ctx.fillRect(0, canvas.height - lowerPadding, canvas.width, 1);

	ctx.fillRect(w * gameScale, upperPadding, 1, canvas.height - lowerPadding - upperPadding);

	ctx.globalAlpha = 1.0;
	ctx.fillStyle = "#FF0000";

	ctx.font = "12px Arial";
	var y = 30;

	Object.keys(this.players).forEach((key) => {
		var name = this.players[key].name;
		if (name)
		{
		  	ctx.fillText(name, 10, y);
		    y += 16;
		}
	});

	ctx.font = "14px Arial";
	ctx.textAlign = "left";
	var time = (this.time) / 1000;
	var secs = Math.floor(time) % 60;
	if (secs < 10)
		secs = "0" + secs;
	var mins = Math.floor(time / 60);
	if (mins < 10)
		mins = "0" + mins;

	var endTime = (this.endTime) / 1000;
	var esecs = Math.floor(endTime) % 60;
	if (esecs < 10)
		esecs = "0" + esecs;
	var emins = Math.floor(endTime / 60);
	if (emins < 10)
		emins = "0" + emins;
	ctx.fillText(mins + ":" + secs + " / " + emins + ":" + esecs, 10, canvas.height - 20);

	ctx.restore();
	requestAnimationFrame(this.draw.bind(this));
	this.renderReplayUI();
}

function Box(x, y, w, h, a) {
  this.alpha = a;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
  this.preserve = true;
}                 

Box.prototype.update = function(dTime, ctx) {

  this.alpha -= dTime * 0.005;
  if (this.alpha <= 0)
  {
    this.kill();
  }
  else
  { 
    ctx.beginPath();
    ctx.lineWidth = 1;

    ctx.globalAlpha = this.alpha * 0.1;
    ctx.fillStyle = "red";
    ctx.fillRect(this.x, this.y, this.w, this.h);

    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = "red";
    ctx.rect(this.x, this.y, this.w, this.h);
    ctx.stroke();
  }
}


module.exports = replay;
